export default __webpack_public_path__ + "static/media/Gopal Krishan.dcf7f846.jpg";